import WsService from "../WsService";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/transactions/transaction";

export default class ResendPaymentReferenceService {
  static resendPaymentReference(transactionId) {
    const endpoint = `${ENDPOINT_BASE}/${transactionId}/payment-reference/resend`;

    const transactionHeaders = UserSessionService.retrieveTransactingHeaders();
    const headers = {
      ...transactionHeaders,
    };

    return WsService.postWithHeaders(endpoint, {}, 200, headers).then(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }
}
